export default "__VITE_ASSET__3a236f38__"